import angular from 'angular';
import ConfirmationOrderService from "../confirmation-order.service";

let inject = ['$scope', '$uibModalInstance', 'SessionService', '$timeout', '$state', 'ConfirmationOrderService','orderData'];

class ModalExperienceController {

    constructor($scope, $uibModalInstance, SessionService, $timeout, $state, ConfirmationOrderService,orderData) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.SessionService = SessionService;
        this.$timeout = $timeout;
        this.$state = $state;

        this.confirmationOrderService = ConfirmationOrderService;

        this.alreadySend = false;
        this.dataForm = {};
        this.orderData = orderData;
    }

    $onInit() {
        if(this.orderData.experience_comment){
            this.alreadySend = true;
            this.dataForm.comment = this.orderData.experience_comment;
            this.dataForm.rating = this.orderData.experience_rating;
        }
    }

    submit(submitForm) {

        if (submitForm.$valid && this.dataForm.rating > 0) {

            let params = {
                orderId: this.orderData.id,
                qualification: this.dataForm.rating,
                commentary: this.dataForm.comment
            };

            this.confirmationOrderService.sendExperienceComment(params).then(value => {

                if (!value.error) {
                    this.dataForm.comment = '';
                    submitForm.comment.$pristine = true;
                    this.dataForm.rating = 0;
                }

                this.$uibModalInstance.close(value);

            }).catch(err => {
                console.log(err);
            });

        } else {
            angular.forEach(submitForm.$error.required, function (field) {
                field.$setDirty();
            });

            if (this.dataForm.rating === 0 || !this.ratingSelected) {
                this.ratingSelected = true;
            }
        }
    }

    onItemRating(rating) {
        this.dataForm["rating"] = rating;
        this.ratingSelected = rating === 0;
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }


}

ModalExperienceController.$inject = inject;

export default ModalExperienceController;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/confirmation-order/modal-experience/modal-experience.controller.js
 **/